import { render, staticRenderFns } from "./tiga-rates.vue?vue&type=template&id=344ad546&scoped=true"
import script from "./tiga-rates.vue?vue&type=script&lang=js"
export * from "./tiga-rates.vue?vue&type=script&lang=js"
import style0 from "./tiga-rates.vue?vue&type=style&index=0&id=344ad546&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ad546",
  null
  
)

export default component.exports